import { DOCUMENT } from '@angular/common';
import { APP_INITIALIZER, inject } from '@angular/core';
import {
    OneTrustConfig,
    oneTrustScriptLoader,
} from '@de-care/shared/angular/configuration-tokens-onetrust';

export function provideOneTrust({
    oneTrustConfig,
}: {
    oneTrustConfig: OneTrustConfig;
}) {
    if (oneTrustConfig.disabled) {
        return [];
    }
    return [
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                const document = inject(DOCUMENT);
                return () => {
                    oneTrustScriptLoader(oneTrustConfig, document);
                };
            },
            multi: true,
        },
    ];
}
